import { Text } from 'shared/ui/common/Text'
import { Button } from 'shared/ui/controls/Button'
import { ProgressBar } from 'shared/ui/common/ProgressBar'
import { ReactComponent as TimeSVG } from 'assets/time.svg'

import s from './NFCSMintProgress.module.scss'

type Props = {
  title: React.ReactNode
  onClose?: () => void
}

export function NFCSMintProgress({ title, onClose }: Props) {
  return (
    <>
      <Text size={44} weight={700} isUppercased isCentered className={s.title}>
        {title}
      </Text>

      <div className={s.timerWrapOuter}>
        <div className={s.timerSpacer} />
        <div className={s.timerWrapInner}>
          <TimeSVG />
        </div>
        <Text
          size={16}
          weight={600}
          color="secondary"
          isUppercased
          isCentered
          className={s.timerHint}
        >
          Please wait
        </Text>
      </div>

      <Text size={16} weight={600} isUppercased isCentered className={s.text}>
        Your credit score is being generated
      </Text>

      <ProgressBar className={s.progress} />

      {onClose && (
        <Button isCentered size={60} fashion="glass" onClick={onClose}>
          Close
        </Button>
      )}
    </>
  )
}
